export default __webpack_public_path__ + "static/media/teammates.244bbf4f.png";